.hidden {
  display: none !important; /* eslint-disable-line css/no-important */
}

.invisible {
  visibility: hidden !important; /* eslint-disable-line css/no-important */
}
